import { DeviceMode, isNodeV2, notEmpty } from '@vedalib/editor'
import * as R from 'ramda'

import { getNodeWithFullChildren } from 'components/Editor/EditorContext/selectors/block'
import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { setProjectNavigation, updateBlock } from 'services/Store/Project/actions'
import { omitNodeWithChildren } from 'services/Store/Project/mutators/node'
import { getBlock, getDeviceMode, getSelectedNodeIds } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'
import { t } from 'services/Translation'

export const onCut = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const selection = window.getSelection()
  const isDesktop = getDeviceMode(state) === DeviceMode.desktop

  if (block && selection?.isCollapsed) {
    if (!isDesktop) {
      return notify({
        type: NotificationType.info,
        message: t('editorV2.notifyStructureChangesRestricted'),
      })
    }
    const nodes = selectedNodes.map((id) => {
      const [root, ...nodes] = getNodeWithFullChildren(block, id)
      const elementIds = [root, ...nodes].map((node) => (isNodeV2(node) ? node.elementId : null))
      const elements = R.pick(elementIds.filter(notEmpty), block.elements)
      return { root, nodes: R.indexBy(R.prop('id'), nodes), elements }
    })
    const buffer = JSON.stringify(nodes, null, 2)
    try {
      await navigator.clipboard.writeText(buffer)
      notify({ type: NotificationType.success, message: t('notify.textCut') })
      const cbs = selectedNodes.map(omitNodeWithChildren) as [(block: Block) => Block]
      dispatch(updateBlock({ id: block.uuid, value: R.compose(...cbs)(block) }))
      dispatch(setProjectNavigation({ nodeIds: [] }))
    } catch (err) {
      notify({
        type: NotificationType.error,
        message: t('notify.copiedError'),
        duration: 2000,
      })
    }
  }
}
